import { ComponentType } from 'react';
import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getModuleData, getModuleVersion } from '../../../selectors/modules';
import { Props } from './Deviousness';

type StateProps = Pick<
  Props,
  'moduleVersion' | 'dateAwarded' | 'awardType' | 'description'
>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const { dateAwarded, awardType, description } = getModuleData(
    state,
    ownProps.moduleId
  );
  const moduleVersion = getModuleVersion(state, ownProps.moduleId);
  return {
    moduleVersion,
    dateAwarded,
    awardType,
    description,
  };
};

export default connect(mapStateToProps) as (
  component: ComponentType<Props>
) => ComponentType<OwnProps>;
